export default {
  index: [
    {
      path: '/qykjuser',
      component: resolve => require(['./qykjuserIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/qykjuser/_router.js